import { render, staticRenderFns } from "./AddToCollection.vue?vue&type=template&id=dc99bec6&scoped=true"
import script from "./AddToCollection.vue?vue&type=script&lang=js"
export * from "./AddToCollection.vue?vue&type=script&lang=js"
import style0 from "./AddToCollection.vue?vue&type=style&index=0&id=dc99bec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc99bec6",
  null
  
)

export default component.exports